/**
 * Monta a sessão que a API importa a partir do cookie `sessionid` do navegador.
 * O login com senha da biblioteca usa um endpoint que o Instagram recusa
 * (`needs_upgrade`); a sessão do site entra pelo header `IGT:2`.
 * O `sessionid` começa pelo id numérico da conta: `123456%3Aabc%3A...`.
 */
export function sessaoInstagramDoCookie(
  bruto: string,
): Record<string, unknown> | null {
  const limpo = bruto.trim().replace(/^sessionid=/, "").replace(/;$/, "");
  let sessionid: string;
  try {
    sessionid = decodeURIComponent(limpo);
  } catch {
    return null;
  }
  const dsUserId = sessionid.split(":")[0] ?? "";
  if (!/^\d+$/.test(dsUserId) || sessionid.length < dsUserId.length + 10) {
    return null;
  }
  const igt = btoa(
    JSON.stringify({
      ds_user_id: dsUserId,
      sessionid,
      should_use_header_over_cookies: true,
    }),
  );
  return { authorization: `Bearer IGT:2:${igt}` };
}
